import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EditorDataService } from '../editor-data/editor-data.service';
import { EditorEligibilityRuleHasBookingType } from '../editor-eligibility-rule/editor-eligibility-rule-has-booking-type.model';


@Component({
    selector: 'eas-editor-eligibility-rule-value-has-booking-type',
    templateUrl: './editor-eligibility-rule-value.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorEligibilityRuleValueHasBookingTypeComponent implements OnInit, OnChanges, OnDestroy {
  @Input() rule: EditorEligibilityRuleHasBookingType;
  @Input() affirmative: boolean;

  private destroyed$ = new Subject<void>();

  bookingTypeNames: { id: string, name: string }[];
  bookingStateNames: { id: string, name: string }[];
  bookingMetadataNames: { id: string, name: string }[];

  value: string;

  constructor(private editorData: EditorDataService) {

  }

  ngOnInit() {
    this.editorData.bookingTypeNames$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        bookingTypeNames => {
          this.bookingTypeNames = bookingTypeNames;
          this.value = this.getValue();
        }
      );

    this.editorData.bookingStateNames$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        bookingStateNames => {
          this.bookingStateNames = bookingStateNames;
          this.value = this.getValue();
        }
      );

    this.editorData.bookingMetadataNames$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        bookingMetadataNames => {
          this.bookingMetadataNames = bookingMetadataNames;
          this.value = this.getValue();
        }
      );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.rule || changes.affirmative) {
      this.value = this.getValue();
    }
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  getValue(): string {
    if (this.bookingTypeNames === undefined || this.bookingStateNames === undefined || this.bookingMetadataNames === undefined) {
      return $localize `Not available`;
    }

    const bookingTypes = this.rule.getBookingTypesAsString(this.bookingTypeNames);
    let value = this.affirmative
      ? $localize `Candidate has one of the booking types ${bookingTypes}`
      : $localize `Candidate has NONE of the booking types ${bookingTypes}`;

    const bookingStates = this.rule.stateNamesString;
    // const bookingStates = this.rule.getBookingStatesAsString(this.bookingStateNames);
    if (bookingStates !== '') {
      value = this.affirmative
        ? $localize `${value} in one of the states ${bookingStates}`
        : $localize `${value} in any of the states ${bookingStates}`;
    }

    const bookingMetadata = this.rule.getBookingMetadataAsString(this.bookingMetadataNames);
    if (bookingMetadata !== '') {
      value = $localize `${value} with metadata ${bookingMetadata}`;
    }

    return value;
  }
}
